<div class="no-access">
  <div class="no-access-hero">
    <div class="wtw-container">
      <div class="no-access-header">
        <h1 class="wtw-typography-display--xl wtw-typography-font-weight--semibold">
          {{ txt.header }}
        </h1>
        <img src="assets/images/no-access-icon.svg" alt="No Access" />
      </div>
    </div>
  </div>
  <div class="wtw-container">
    <div class="no-access-body">
      <h2 class="wtw-typography-display--sm wtw-typography-font-weight--semibold wtw-base--900">
        {{ (txt.subheader ? txt.subheader.replace('{{MODULE}}', data()?.moduleName ?? '') : '') }}
      </h2>

      <button class="wtw-button wtw-button--secondary wtw-button-size--md" [routerLink]="['/']">
        <span>{{ txt.cta }}</span>
      </button>
    </div>
  </div>
</div>
